import {
  AmbientTradeDetails,
  AquariusSwapsTriggerDetails,
  AquariusTriggerDetails,
  BlendTriggerDetails,
  CompoundV3TriggerDetails,
  DiscordTriggerDetails,
  DuneQueryTriggerDetails,
  EulerV2LoopingTriggerDetails,
  EulerVaultsTriggerDetails,
  ExponentTriggerDetails,
  FelixCdpCollateralTriggerDetails,
  FelixVanillaCollateralTriggerDetails,
  FogoIgnitionLockedTriggerDetails,
  FogoLendTriggerDetails,
  FogoTokenHoldersTriggerDetails,
  GalxeTriggerDetails,
  GearboxTriggerDetails,
  GithubTriggerDetails,
  HibachiAffiliatesTriggerDetails,
  HibachiTradingTriggerDetails,
  HyperliquidTradeDetails,
  HypurrCardTransactionsTriggerDetails,
  HypurrEulerNetPositionsTriggerDetails,
  HypurrNetPoolPositionsTriggerDetails,
  LiquidPoolTriggerDetails,
  LynxTradeTriggerDetails,
  MorphoBorrowerStrategyTriggerDetails,
  MorphoTriggerDetails,
  MorphoVaultsTriggerDetails,
  NadoTriggerDetails,
  OdysseyBuilderTradesTriggerDetails,
  OffChainTriggerDetails,
  OnChainTriggerDetails,
  OrderlyTriggerDetails,
  PacificaBuilderTradesTriggerDetails,
  PendleLPTriggerDetails,
  PendleTriggerDetails,
  PolymarketTradeVolumeTriggerDetails,
  PyronTriggerDetails,
  SolanaTokenHoldersTriggerDetails,
  SpectraLPTriggerDetails,
  SpectraYTTriggerDetails,
  StellarTokenHoldersTriggerDetails,
  StripePaymentTriggerDetails,
  SubgraphTriggerDetails,
  SuiTokenHoldersTriggerDetails,
  TokenHolderTriggerDetails,
  UniswapV4PoolTriggerDetails,
  ValiantLiquidityDetails,
  ValiantTradeDetails,
  XFollowTriggerDetails,
  XLikeTriggerDetails,
  XPostTriggerDetails,
  XRepostTriggerDetails,
  ZealyTriggerDetails,
} from '../components/trigger-type-details';
import { TriggerType } from '../types';
import { EventTriggerType, EventType, Trigger } from '.';

// TODO: when trigger presets are done, we can remove this and handle the componentes with TriggerType directly
export const getTriggerEventType = (trigger: Trigger): EventTriggerType => {
  switch (trigger.triggerType) {
    case TriggerType.Custom:
      switch (trigger.type) {
        case EventType.OnChainEvent:
          return EventTriggerType.OnChain;
        case EventType.OnChainFunction:
        case EventType.OnChainInternalFunction:
          return EventTriggerType.OnChainFunction;
        case EventType.OnChainTokenHolder:
          return EventTriggerType.OnChainTokenHolder;
        case EventType.OnChainSubgraphEvent:
          // @deprecated - signature-based detection for legacy triggers
          if (trigger.signature.startsWith('SubgraphBalance-PendleYT')) {
            return EventTriggerType.Pendle;
          }
          if (trigger.signature.startsWith('SubgraphBalance-Morpho')) {
            return EventTriggerType.Morpho;
          }
          // @deprecated - signature-based detection for legacy triggers
          if (trigger.signature.startsWith('SubgraphBalance-Lynx')) {
            return EventTriggerType.LynxTrade;
          }
          return EventTriggerType.OnChainSubgraphEvent;
        default:
          // @deprecated - signature-based detection for legacy triggers
          if (trigger.signature.startsWith('x-follow-')) {
            return EventTriggerType.XFollowEvent;
          }
          if (trigger.signature.startsWith('SUI-TokenHolders-')) {
            return EventTriggerType.SuiTokenHolders;
          }
          if (trigger.signature.startsWith('Solana-TokenHolders-')) {
            return EventTriggerType.SolanaTokenHolders;
          }
          if (trigger.endUserIdentifierProperty == 'github_username') {
            return EventTriggerType.Github;
          }
          if (trigger.endUserIdentifierProperty == 'discord_username') {
            return EventTriggerType.Discord;
          }
          return EventTriggerType.CustomEvent;
      }
    case TriggerType.LiquidityPool:
      return EventTriggerType.Uniswap;
    case TriggerType.UniswapLiquidityV3:
      return EventTriggerType.Uniswap;
    case TriggerType.UniswapLiquidityV4:
      return EventTriggerType.UniswapV4;
    case TriggerType.HybraLiquidityV3:
      return EventTriggerType.HybraLiquidityV3;
    case TriggerType.HyperswapLiquidityV3:
      return EventTriggerType.HyperswapLiquidityV3;
    case TriggerType.PrjXLiquidityV3:
      return EventTriggerType.PrjXLiquidityV3;
    case TriggerType.KittenSwapLiquidityV3:
      return EventTriggerType.KittenSwapLiquidityV3;
    case TriggerType.UltrasolidLiquidityV3:
      return EventTriggerType.UltrasolidLiquidityV3;
    case TriggerType.UpheavalLiquidityV3:
      return EventTriggerType.UpheavalLiquidityV3;
    case TriggerType.NestLiquidityV3:
      return EventTriggerType.NestLiquidityV3;
    case TriggerType.DuneQuery:
      return EventTriggerType.Dune;
    case TriggerType.PendleLPToken:
      return EventTriggerType.PendleLP;
    case TriggerType.ZealyQuest:
      return EventTriggerType.Zealy;
    case TriggerType.GalxeQuest:
      return EventTriggerType.Galxe;
    case TriggerType.NadoTrade:
      return EventTriggerType.NadoTrade;
    case TriggerType.NadoPurpsTrade:
      return EventTriggerType.NadoPurpsTrade;
    case TriggerType.VertexTrade:
      return EventTriggerType.NadoTrade;
    case TriggerType.Balancer:
      return EventTriggerType.BalancerPool;
    case TriggerType.CompoundV3:
      return EventTriggerType.CompoundV3;
    case TriggerType.MorphoBorrowerStrategy:
      return EventTriggerType.MorphoBorrowerStrategy;
    case TriggerType.TokenHolder:
      return EventTriggerType.OnChainTokenHolder;
    case TriggerType.LiquidityPoolV2:
      return EventTriggerType.OnChainV2Liquidity;
    case TriggerType.HypurrNetPoolPositions:
      return EventTriggerType.HypurrNetPoolPositions;
    case TriggerType.HypurrEulerNetPositions:
      return EventTriggerType.HypurrEulerNetPositions;
    case TriggerType.HibachiTrading:
      return EventTriggerType.HibachiTrading;
    case TriggerType.HibachiAffiliateReferredFees:
      return EventTriggerType.HibachiAffiliates;
    case TriggerType.AmbientTrade:
      return EventTriggerType.AmbientTrade;
    case TriggerType.HyperliquidTrade:
      return EventTriggerType.HyperliquidTrade;
    case TriggerType.ValiantTrade:
      return EventTriggerType.ValiantTrade;
    case TriggerType.ValiantLiquidity:
      return EventTriggerType.ValiantLiquidity;
    case TriggerType.OrderlyBuilderTrades:
      return EventTriggerType.OrderlyBuilderTrades;
    case TriggerType.TwitterVerifyPost:
      return EventTriggerType.XPostEvent;
    case TriggerType.TwitterVerifyRetweet:
      return EventTriggerType.XRepostEvent;
    case TriggerType.TwitterVerifyLike:
      return EventTriggerType.XLikeEvent;
    case TriggerType.SolanaTokenHolder:
      return EventTriggerType.SolanaTokenHolders;
    case TriggerType.LynxTrade:
      return EventTriggerType.LynxTrade;
    case TriggerType.SubgraphBalance:
      return EventTriggerType.OnChainSubgraphEvent;
    case TriggerType.FollowOnX:
      return EventTriggerType.XFollowEvent;
    case TriggerType.PendleYT:
      return EventTriggerType.Pendle;
    case TriggerType.Pyron:
      return EventTriggerType.Pyron;

    case TriggerType.BlendPositions:
      return EventTriggerType.BlendPositions;

    case TriggerType.AquariusLiquidity:
      return EventTriggerType.AquariusLiquidity;
    case TriggerType.AquariusSwaps:
      return EventTriggerType.AquariusSwaps;
    case TriggerType.Exponent:
      return EventTriggerType.Exponent;
    case TriggerType.FogoLend:
      return EventTriggerType.FogoLend;
    case TriggerType.FelixVanillaCollateral:
      return EventTriggerType.FelixVanillaCollateral;
    case TriggerType.FelixCdpCollateral:
      return EventTriggerType.FelixCdpCollateral;
    case TriggerType.FogoTokenHolder:
      return EventTriggerType.FogoTokenHolders;
    case TriggerType.StellarTokenHolder:
      return EventTriggerType.StellarTokenHolders;
    case TriggerType.FogoIgnitionLocked:
      return EventTriggerType.FogoIgnitionLocked;
    case TriggerType.HypurrCardTransactions:
      return EventTriggerType.HypurrCardTransactions;
    case TriggerType.PolymarketTradeVolume:
      return EventTriggerType.PolymarketTradeVolume;
    case TriggerType.Gearbox:
      return EventTriggerType.Gearbox;
    case TriggerType.PacificaBuilderTrades:
      return EventTriggerType.PacificaBuilderTrades;
    case TriggerType.OdysseyBuilderTrades:
      return EventTriggerType.OdysseyBuilderTrades;
    case TriggerType.MorphoVaults:
      return EventTriggerType.MorphoVaults;
    case TriggerType.EulerV2Looping:
      return EventTriggerType.EulerV2Looping;
    case TriggerType.EulerVaults:
      return EventTriggerType.EulerVaults;
    case TriggerType.SpectraYT:
      return EventTriggerType.SpectraYT;
    case TriggerType.SpectraLP:
      return EventTriggerType.SpectraLP;
    case TriggerType.DiscordServerJoin:
      return EventTriggerType.DiscordServerJoin;
    case TriggerType.DiscordRoleAssigned:
      return EventTriggerType.DiscordRoleAssigned;
    case TriggerType.StripePayment:
      return EventTriggerType.StripePayment;
    default:
      return EventTriggerType.CustomEvent;
  }
};

// Mapper for trigger types to their respective components - memoized outside component since it never changes
export const TRIGGER_COMPONENT_MAP: Partial<
  Record<EventTriggerType, React.ComponentType<{ trigger: Trigger; triggerType: EventTriggerType }>>
> = {
  [EventTriggerType.OnChain]: OnChainTriggerDetails,
  [EventTriggerType.OnChainFunction]: OnChainTriggerDetails,
  [EventTriggerType.CustomEvent]: OffChainTriggerDetails,
  [EventTriggerType.OnChainTokenHolder]: TokenHolderTriggerDetails,
  [EventTriggerType.OnChainSubgraphEvent]: SubgraphTriggerDetails,
  [EventTriggerType.Dune]: DuneQueryTriggerDetails,
  [EventTriggerType.Zealy]: ZealyTriggerDetails,
  [EventTriggerType.Galxe]: GalxeTriggerDetails,
  [EventTriggerType.NadoTrade]: NadoTriggerDetails,
  [EventTriggerType.NadoPurpsTrade]: NadoTriggerDetails,
  [EventTriggerType.PendleLP]: PendleLPTriggerDetails,
  [EventTriggerType.Pendle]: PendleTriggerDetails,
  [EventTriggerType.Uniswap]: LiquidPoolTriggerDetails,
  [EventTriggerType.UniswapV4]: UniswapV4PoolTriggerDetails,
  [EventTriggerType.HybraLiquidityV3]: LiquidPoolTriggerDetails,
  [EventTriggerType.HyperswapLiquidityV3]: LiquidPoolTriggerDetails,
  [EventTriggerType.PrjXLiquidityV3]: LiquidPoolTriggerDetails,
  [EventTriggerType.KittenSwapLiquidityV3]: LiquidPoolTriggerDetails,
  [EventTriggerType.UltrasolidLiquidityV3]: LiquidPoolTriggerDetails,
  [EventTriggerType.UpheavalLiquidityV3]: LiquidPoolTriggerDetails,
  [EventTriggerType.NestLiquidityV3]: LiquidPoolTriggerDetails,
  [EventTriggerType.XFollowEvent]: XFollowTriggerDetails,
  [EventTriggerType.XPostEvent]: XPostTriggerDetails,
  [EventTriggerType.XRepostEvent]: XRepostTriggerDetails,
  [EventTriggerType.XLikeEvent]: XLikeTriggerDetails,
  [EventTriggerType.Github]: GithubTriggerDetails,
  [EventTriggerType.Discord]: DiscordTriggerDetails,
  [EventTriggerType.DiscordServerJoin]: DiscordTriggerDetails,
  [EventTriggerType.DiscordRoleAssigned]: DiscordTriggerDetails,
  [EventTriggerType.Morpho]: MorphoTriggerDetails,
  [EventTriggerType.LynxTrade]: LynxTradeTriggerDetails,
  [EventTriggerType.BalancerPool]: TokenHolderTriggerDetails,
  [EventTriggerType.CompoundV3]: CompoundV3TriggerDetails,
  [EventTriggerType.MorphoBorrowerStrategy]: MorphoBorrowerStrategyTriggerDetails,
  [EventTriggerType.OnChainV2Liquidity]: TokenHolderTriggerDetails,
  [EventTriggerType.HypurrNetPoolPositions]: HypurrNetPoolPositionsTriggerDetails,
  [EventTriggerType.HypurrEulerNetPositions]: HypurrEulerNetPositionsTriggerDetails,
  [EventTriggerType.HibachiTrading]: HibachiTradingTriggerDetails,
  [EventTriggerType.HibachiAffiliates]: HibachiAffiliatesTriggerDetails,
  [EventTriggerType.AmbientTrade]: AmbientTradeDetails,
  [EventTriggerType.HyperliquidTrade]: HyperliquidTradeDetails,
  [EventTriggerType.ValiantTrade]: ValiantTradeDetails,
  [EventTriggerType.ValiantLiquidity]: ValiantLiquidityDetails,
  [EventTriggerType.OrderlyBuilderTrades]: OrderlyTriggerDetails,
  [EventTriggerType.AquariusLiquidity]: AquariusTriggerDetails,
  [EventTriggerType.AquariusSwaps]: AquariusSwapsTriggerDetails,
  [EventTriggerType.BlendPositions]: BlendTriggerDetails,
  [EventTriggerType.Pyron]: PyronTriggerDetails,
  [EventTriggerType.Exponent]: ExponentTriggerDetails,
  [EventTriggerType.FogoLend]: FogoLendTriggerDetails,
  [EventTriggerType.FelixVanillaCollateral]: FelixVanillaCollateralTriggerDetails,
  [EventTriggerType.FelixCdpCollateral]: FelixCdpCollateralTriggerDetails,
  [EventTriggerType.SolanaTokenHolders]: SolanaTokenHoldersTriggerDetails,
  [EventTriggerType.SuiTokenHolders]: SuiTokenHoldersTriggerDetails,
  [EventTriggerType.FogoTokenHolders]: FogoTokenHoldersTriggerDetails,
  [EventTriggerType.StellarTokenHolders]: StellarTokenHoldersTriggerDetails,
  [EventTriggerType.HypurrCardTransactions]: HypurrCardTransactionsTriggerDetails,
  [EventTriggerType.FogoIgnitionLocked]: FogoIgnitionLockedTriggerDetails,
  [EventTriggerType.PolymarketTradeVolume]: PolymarketTradeVolumeTriggerDetails,
  [EventTriggerType.Gearbox]: GearboxTriggerDetails,
  [EventTriggerType.PacificaBuilderTrades]: PacificaBuilderTradesTriggerDetails,
  [EventTriggerType.OdysseyBuilderTrades]: OdysseyBuilderTradesTriggerDetails,
  [EventTriggerType.MorphoVaults]: MorphoVaultsTriggerDetails,
  [EventTriggerType.EulerV2Looping]: EulerV2LoopingTriggerDetails,
  [EventTriggerType.EulerVaults]: EulerVaultsTriggerDetails,
  [EventTriggerType.SpectraYT]: SpectraYTTriggerDetails,
  [EventTriggerType.SpectraLP]: SpectraLPTriggerDetails,
  [EventTriggerType.StripePayment]: StripePaymentTriggerDetails,
};

export const TRIGGER_TYPE_MAP: Partial<Record<EventTriggerType, string>> = {
  [EventTriggerType.OnChain]: 'On-Chain Event',
  [EventTriggerType.OnChainFunction]: 'On-Chain Function',
  [EventTriggerType.CustomEvent]: 'Off-Chain Event',
  [EventTriggerType.OnChainTokenHolder]: 'EVM Token Holder',
  [EventTriggerType.NadoTrade]: 'Nado',
  [EventTriggerType.NadoPurpsTrade]: 'Nado Purps',
  [EventTriggerType.PendleLP]: 'PendleLP',
  [EventTriggerType.Pendle]: 'PendleYT',
  [EventTriggerType.OnChainSubgraphEvent]: 'Subgraph',
  [EventTriggerType.Uniswap]: 'Uniswap v3',
  [EventTriggerType.UniswapV4]: 'Uniswap v4',
  [EventTriggerType.HybraLiquidityV3]: 'Hybra',
  [EventTriggerType.HyperswapLiquidityV3]: 'HyperSwap',
  [EventTriggerType.PrjXLiquidityV3]: 'Prj X v3',
  [EventTriggerType.KittenSwapLiquidityV3]: 'KittenSwap v3',
  [EventTriggerType.UltrasolidLiquidityV3]: 'Ultrasolid v3',
  [EventTriggerType.UpheavalLiquidityV3]: 'Upheaval v3',
  [EventTriggerType.NestLiquidityV3]: 'Nest v3',
  [EventTriggerType.Dune]: 'Dune Query',
  [EventTriggerType.XFollowEvent]: 'Follow on X',
  [EventTriggerType.XPostEvent]: 'Post on X',
  [EventTriggerType.XRepostEvent]: 'Repost on X',
  [EventTriggerType.XLikeEvent]: 'Like on X',
  [EventTriggerType.Github]: 'Github',
  [EventTriggerType.Discord]: 'Discord',
  [EventTriggerType.DiscordServerJoin]: 'Discord Server Join',
  [EventTriggerType.DiscordRoleAssigned]: 'Discord Role Assigned',
  [EventTriggerType.Zealy]: 'Zealy',
  [EventTriggerType.Galxe]: 'Galxe',
  [EventTriggerType.Morpho]: 'Morpho Vaults - Performance Fee',
  [EventTriggerType.LynxTrade]: 'Lynx Trade',
  [EventTriggerType.BalancerPool]: 'Balancer',
  [EventTriggerType.CompoundV3]: 'Compound v3',
  [EventTriggerType.MorphoBorrowerStrategy]: 'Morpho Market Strategies',
  [EventTriggerType.OnChainV2Liquidity]: 'Liquidity Pool V2',
  [EventTriggerType.HypurrNetPoolPositions]: 'Hypurr Net Pooled Positions',
  [EventTriggerType.HypurrEulerNetPositions]: 'Hypurr Euler Net Positions',
  [EventTriggerType.HibachiTrading]: 'Hibachi Trade',
  [EventTriggerType.HibachiAffiliates]: 'Hibachi Affiliates',
  [EventTriggerType.AmbientTrade]: 'Ambient Trade',
  [EventTriggerType.HyperliquidTrade]: 'Hyperliquid Trade',
  [EventTriggerType.ValiantTrade]: 'Valiant Trade',
  [EventTriggerType.ValiantLiquidity]: 'Valiant Liquidity',
  [EventTriggerType.OrderlyBuilderTrades]: 'Orderly Builder Trades',
  [EventTriggerType.AquariusLiquidity]: 'Aquarius Liquidity',
  [EventTriggerType.AquariusSwaps]: 'Aquarius Swaps',
  [EventTriggerType.BlendPositions]: 'Blend',
  [EventTriggerType.Pyron]: 'Pyron',
  [EventTriggerType.Exponent]: 'Exponent',
  [EventTriggerType.FogoLend]: 'FogoLend',
  [EventTriggerType.FelixVanillaCollateral]: 'Felix Vanilla Collateral',
  [EventTriggerType.FelixCdpCollateral]: 'Felix CDP Collateral',
  [EventTriggerType.SolanaTokenHolders]: 'Solana Token Holders',
  [EventTriggerType.SuiTokenHolders]: 'SUI Token Holders',
  [EventTriggerType.FogoTokenHolders]: 'Fogo Token Holders',
  [EventTriggerType.StellarTokenHolders]: 'Stellar Token Holders',
  [EventTriggerType.HypurrCardTransactions]: 'HypurrFi Card Transaction',
  [EventTriggerType.FogoIgnitionLocked]: 'Ignition Locked iFOGO',
  [EventTriggerType.PolymarketTradeVolume]: 'Polymarket Trade Volume',
  [EventTriggerType.Gearbox]: 'Gearbox',
  [EventTriggerType.PacificaBuilderTrades]: 'Pacifica Trades',
  [EventTriggerType.OdysseyBuilderTrades]: 'Odyssey Builder Trades',
  [EventTriggerType.MorphoVaults]: 'Deposit on Morpho Vaults',
  [EventTriggerType.EulerV2Looping]: 'Euler V2 Looping - Net Deposit',
  [EventTriggerType.EulerVaults]: 'Deposit on Euler Vaults',
  [EventTriggerType.SpectraYT]: 'Spectra YT',
  [EventTriggerType.SpectraLP]: 'Spectra LP',
  [EventTriggerType.StripePayment]: 'Stripe Payment',
};
